import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Busyable } from 'src/app/shared/editors/busyable';
import { ApiServiceBase } from 'src/app/Services/api.service.base';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { SetOccupancyComponent } from '../setoccupancy/setoccupancy.component';
@Component({
    selector: 'app-customergroup',
    templateUrl: './customergroup.component.html',
    styleUrls: ['./customergroup.component.scss'],
    standalone: false
})
export class CustomergroupComponent extends Busyable implements OnInit {

  public ModelId: any;
  public Model: any;

  constructor(private apiService: ApiServiceBase, private parentRoute: ActivatedRoute, private modalService: SimpleModalService) {
    super();
  }

  ngOnInit(): void {
    this.Loading();
    this.parentRoute.params.subscribe(params => { 
      this.ModelId = params['id']; 
      this.loadModel();
    });
  }

  private loadModel(): void {
    this.apiService.Get<any>("parking/customergroups/" + this.ModelId).then(result => {
      this.Model = result;
      this.StopLoading();
    }).catch(error => {
      console.error('Error loading customer group:', error);
      this.StopLoading();
    });
  }

  public SetOccupancy(): void {
    this.modalService.addModal(SetOccupancyComponent, { 
      "ModelId": this.Model.Id,
      "currentOccupancy": this.Model.OccupiedSpaces || 0
    })
      .subscribe((result: any) => {
        if (result === true) {
          // Refresh the model to get updated occupancy values
          this.loadModel();
        }
      });
  }
} 
